import { render, staticRenderFns } from "./materialModal.vue?vue&type=template&id=3653d1c7&scoped=true&"
import script from "./materialModal.vue?vue&type=script&lang=js&"
export * from "./materialModal.vue?vue&type=script&lang=js&"
import style0 from "./materialModal.vue?vue&type=style&index=0&id=3653d1c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3653d1c7",
  null
  
)

export default component.exports